import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { OverlayPositionX } from 'apps/webcomponents/src/ui/gzSelect/types';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateExchangeProtection = document.createElement('template');

templateExchangeProtection.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <style>${styleHelpersStyles}</style>

  <header class="page__header">
    <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'</gz-title>
  </header>

  <section class="wrapper" data-wrapper>
    <gz-grid-view>
      <div class="header__actions" slot="grid-header-actions-slot">
        <gz-button data-save id="saveTask" class="mr-2"></gz-button>
        <gz-select overlaypositionx="${OverlayPositionX.LEFT}" class="mr-2" id="openActions">
         <gz-button class="action-button" type="quiet" color="secondary">
           <span data-actions class="action-button-text"></span>
           <span class="action-icon ds-icon-dropdown_arrow"></span>
         </gz-button>
       </gz-select>
       <gz-button type="quiet" color="secondary" id="empty-quarantine" class="mr-2" disabled></gz-button>
       <gz-button type="outline" color="negative" id="delete-task" class="mr-2" disabled></gz-button>
            <span id='delete-button-text'></span>
       </gz-button>
      </div>
    </gz-grid-view>
  </section>
  `;
